import { EnumOption } from "lib/models/faq-models";
import { FAQDataService, FAQDataServiceFactory } from "lib/services/faq-service";
import { useEffect, useState } from "react";

export const useFAQData = () => {
  const [categories, setCategories] = useState<Record<number, string>>({});
  const [loadingFAQ, setLoadingFAQ] = useState(true);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    let isMounted = true;
    const provider: FAQDataService = FAQDataServiceFactory.create();

    provider
      .getMetadata()
      .then((metadata) => {
        const categoryEnums = metadata.enums.category ?? [];
        const categoryDict: Record<number, string> = {};
        for (const enumOption of categoryEnums) {
          categoryDict[enumOption.value as number] = enumOption.label;
        }
        setCategories(categoryDict);
        setLoadingFAQ(false);
      })
      .catch((error) => {
        setLoadingFAQ(false);
        setHasError(true);
      })
      .finally(() => {
        setLoadingFAQ(false);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return { categories, loadingFAQ, hasError };
};
